import { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/** Verifies the ?token=... insider magic-link and sets session. */
export default function InsiderMagicLinkVerify() {
  const navigate = useNavigate();
  const location = useLocation();
  const done = useRef(false);
  const [status, setStatus] = useState('Verifying magic link...');

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('Missing token');
      return;
    }
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${API}/insider/auth/magic-link/verify?token=${encodeURIComponent(token)}`, true);
    xhr.onload = () => {
      if (xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);
        localStorage.setItem('insider_session_token', data.session_token);
        toast.success('Welcome to KBInsider!');
        navigate('/insider/dashboard', { replace: true });
      } else {
        try {
          const err = JSON.parse(xhr.responseText);
          const msg = err.detail?.message || err.detail || 'Invalid or expired link';
          setStatus(msg);
          toast.error(msg);
        } catch { setStatus('Invalid or expired link'); }
      }
    };
    xhr.onerror = () => setStatus('Network error');
    xhr.send();
  }, [location.search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white p-6">
      <div className="text-center max-w-md">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-400 mx-auto mb-4"></div>
        <p className="text-white/70">{status}</p>
        <button onClick={() => navigate('/kbinsider')} className="mt-6 text-amber-400 underline text-sm">Back to KBInsider</button>
      </div>
    </div>
  );
}
